<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <span class="configurationBannerLabel">Performance Inputs</span>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (fanSpeedSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Fan Speed:</span>
            <select class="configurationInputField" #fanSpeedInput
              [class.invalidConfigurationSelection]="isInvalidSelection(fanSpeedSelection.Name)"
              (change)="selectionChanged(fanSpeedSelection, fanSpeedInput.value)"
              [value]="fanSpeedSelection.Value.toString()">
              @for (allowable of fanSpeedSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="fanSpeedSelection.Value && fanSpeedSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (espSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">ESP:</span>
            <input type="number" class="configurationRatingTextInput" #espInput [value]="espSelection.Value"
              step="0.01" (change)="selectionChanged(espSelection, espInput.value || '0')">
            <span class="configurationRatingUnitLabel">{{ getPressureMeasurementUnits() }}</span>
          </span>
        }
        @if (altitudeSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Altitude:</span>
            <input type="number" class="configurationRatingTextInput" #altitudeInput
              [value]="altitudeSelection.Value"
              (change)="selectionChanged(altitudeSelection, altitudeInput.value)">
            <span class="configurationRatingUnitLabel">{{ getDistanceMeasurementUnits() }}</span>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (inputTypeSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Input Type:</span>
            <select class="configurationInputField" #inputTypeInput
              [class.invalidConfigurationSelection]="isInvalidSelection(inputTypeSelection.Name)"
              (change)="inputTypeChanged(inputTypeInput.value)" [value]="inputTypeSelection.Value">
              @for (allowable of inputTypeSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                            [selected]="inputTypeSelection.Value !== undefined && inputTypeSelection.Value !== null
                                     && inputTypeSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (ecoAirflowSelection) {
          <span class="configurationInput">
            <span class="configurationInputLabel">Eco Motor Airflow:</span>
            <input type="number" class="configurationRatingTextInput" #ecoAirflowInput
              [value]="ecoAirflowSelection.Value"
              (change)="selectionChanged(ecoAirflowSelection, ecoAirflowInput.value || '0')">
            <span class="configurationRatingUnitLabel">{{ getAirflowMeasurementUnits() }}</span>
          </span>
        }
        <span class="configurationInput">
        </span>
      </div>
      <app-performance-input [engineKey]="engineKey()" [selectionEntities]="selectionEntities()" [isMetric]="isMetric"
        (valueChanged)="performanceValueChanged()" [isSureflow]="isSureflow()">
      </app-performance-input>
      @if (ratingResponseError) {
        <div class="ratingError">
          {{ ratingResponseError }}
        </div>
      }
    </div>
  }
</div>
